export default __webpack_public_path__ + "static/media/icon-down-small.c32a162b.svg";